const storage = (kind) => {
  try {
    return typeof window === "undefined" ? null : window[kind];
  } catch {
    return null;
  }
};

export const safeGet = (key, fallback = null, kind = "localStorage") => {
  try {
    return storage(kind)?.getItem(key) ?? fallback;
  } catch {
    return fallback;
  }
};

export const safeSet = (key, value, kind = "localStorage") => {
  try {
    storage(kind)?.setItem(key, String(value));
    return true;
  } catch {
    return false;
  }
};

export const safeRemove = (key, kind = "localStorage") => {
  try {
    storage(kind)?.removeItem(key);
  } catch {
    return false;
  }
  return true;
};

export const safeKeys = (kind = "localStorage") => {
  try {
    const target = storage(kind);
    return target ? Array.from({ length: target.length }, (_, index) => target.key(index)).filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const safeJson = (key, fallback, kind = "localStorage") => {
  try {
    const value = safeGet(key, null, kind);
    return value === null ? fallback : JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const customerAccessToken = () => safeGet("aramfix-customer-token", "") || safeGet("aramfix-user-token", "") || "";

export const storeCustomerSession = (customerToken, accountToken = customerToken) => {
  safeSet("aramfix-customer-token", customerToken || "");
  safeSet("aramfix-user-token", accountToken || customerToken || "");
};

export const clearCustomerSession = () => {
  safeRemove("aramfix-customer-token");
  safeRemove("aramfix-user-token");
};